export default __webpack_public_path__ + "static/media/alert-gold.d56744bb.svg";